<div class="ai-chat" [class.ai-chat--empty]="isEmpty()">
  @if (!isEmpty()) {
    <div #scrollContainer class="ai-chat__messages">
      @for (message of messages(); track message.id) {
        @if (message.role === 'user') {
          <div class="ai-chat__turn ai-chat__turn--user" [attr.data-msg-id]="message.id">
            <div class="ai-chat__bubble">{{ userText(message) }}</div>
          </div>
        } @else {
          <div class="ai-chat__turn ai-chat__turn--assistant">
            <div class="ai-chat__answer">
              @for (block of message.blocks; track block.id) {
                @switch (block.kind) {
                  @case ('text') {
                    <ai-chat-text-block
                      [text]="blockText(block)"
                      [showCaret]="isActiveTextBlock(block) && !reducedMotion"
                      [ariaHidden]="isActiveTextBlock(block)"
                    />
                  }
                  @case ('tool') {
                    <ai-chat-tool-block [tool]="block.tool" />
                  }
                }
              }
            </div>
            @if (message.status === 'error' && message.errorMessage) {
              <glxy-alert type="error" size="small">{{ message.errorMessage }}</glxy-alert>
            }
            @if (isThinking(message)) {
              <glxy-loading-spinner size="small" aria-hidden="true" />
            }
          </div>
        }
      }
      @if (tailSpacerHeight() > 0) {
        <div class="ai-chat__tail" [style.height.px]="tailSpacerHeight()" aria-hidden="true"></div>
      }
    </div>

    <div class="ai-chat__sr-only" role="log" aria-live="polite">{{ lastCompletedAnswer() }}</div>
  } @else {
    <glxy-empty-state>
      <mat-icon glxyEmptyStateHero>forum</mat-icon>
      {{ emptyStateText() || ('AI_ASSISTANT.AI_CHAT.EMPTY_STATE' | translate) }}
    </glxy-empty-state>
  }

  @if (error()) {
    <glxy-alert type="error">{{ error() }}</glxy-alert>
  }

  <form class="ai-chat__composer" (submit)="$event.preventDefault()">
    <glxy-form-field class="ai-chat__field">
      <textarea
        matInput
        [formControl]="draft"
        cdkTextareaAutosize
        cdkAutosizeMinRows="1"
        cdkAutosizeMaxRows="6"
        [placeholder]="placeholder() || ('AI_ASSISTANT.AI_CHAT.PLACEHOLDER' | translate)"
        (keydown.enter)="onEnter($event)"
      ></textarea>
    </glxy-form-field>
    <button
      mat-icon-button
      type="button"
      class="ai-chat__send"
      (click)="submit()"
      [disabled]="isStreaming() || !draft.value.trim()"
      [attr.aria-label]="'AI_ASSISTANT.AI_CHAT.SEND' | translate"
    >
      <mat-icon>send</mat-icon>
    </button>
  </form>
</div>
